export type NumeroPedido = {
  /** Protocolo e sequência separados, para leitura: `TK202610123456 · 02`. */
  exibicao: string
  /** Como o Eyer mostra o Accession Number: o valor cru, sem separador. */
  eyer: string
}

const SEM_NUMERO = '—'

export const formatarNumeroPedido = (
  accessionNumber: string | null | undefined,
  sequencia: number
): NumeroPedido => {
  if (!accessionNumber || accessionNumber.length < 3) {
    return { exibicao: SEM_NUMERO, eyer: SEM_NUMERO }
  }
  return {
    exibicao: `${accessionNumber.slice(0, -2)} · ${String(sequencia).padStart(2, '0')}`,
    eyer: accessionNumber,
  }
}
